import { createSlotRecipe } from './runtime.js';

const sliderConfig = {"name":"slider","slots":["root","label","control","track","range","thumb","valueText","markerGroup","marker","hiddenInput"]}

export const slider = /* @__PURE__ */ createSlotRecipe(sliderConfig)